import { GET_REGIONS } from './regions';
import { GET_COUNTRIES } from './countries';
import { GET_DEAL_SHEET_CONFIGURATION } from './getConfiguration';
import { GET_DEAL_SHEET_CONFIGURATIONS } from './getConfigurations';
import { GET_DEAL_SHEET_TABLE_CONFIGURATIONS } from './getTableListConfigurations';

import { CREATE_DEAL_SHEET_CONFIGURATION } from './createConfiguration';
import { UPDATE_DEAL_SHEET_CONFIGURATION } from './updateConfiguration';
import { DELETE_DEAL_SHEET_CONFIGURATION } from './deleteConfiguration';

export const dealSheetConfigurationApi = {
  getRegions: GET_REGIONS,
  getCountries: GET_COUNTRIES,
  getConfig: GET_DEAL_SHEET_CONFIGURATION,
  getConfigs: GET_DEAL_SHEET_CONFIGURATIONS,
  getTableConfigs: GET_DEAL_SHEET_TABLE_CONFIGURATIONS,

  createConfig: CREATE_DEAL_SHEET_CONFIGURATION,
  updateConfig: UPDATE_DEAL_SHEET_CONFIGURATION,
  deleteConfig: DELETE_DEAL_SHEET_CONFIGURATION,
};

export * from './useDealSheetConfiguration';
